import { Timestamp } from "firebase/firestore";
import React, { useRef, useState } from "react"
import Messages from './Messages';
import { MSG_TYPE_ENUM } from "./Message";
import Input from "./Input";
import ContactModule from "./ContactModule";
import { useVisualizerContext } from "./Visualizer";
import { LIMITS } from "../Limits";

export default function Content({ options, showAutoReply, setShowAutoReply }) {

    const { messages, addMessage, config, banned, name, email, onSolicitSaved, activeVisualTrigger, setMessages } = useVisualizerContext();
    const inputSize = useRef(null);
    const [inputHeight, setInputHeight] = useState(0);

    function getContent() {
        if (activeVisualTrigger === 'contact') {
            options = 1;
        } else if (activeVisualTrigger === 'chat') {
            options = 0;
        }
        if (config.default) {
            options = 0;
        }
        switch (options) {
            case 1:
                return <ContactModule config={config} name={name} email={email} addMessage={addMessage} />
            default:
                if (banned) {
                    //fetchWorkspaceConfig();
                    return (<Messages messages={messages} />);
                }
                return (
                    <>
                        <Messages messages={messages} onSolicitSaved={onSolicitSaved} inputHeight={inputHeight} />
                        {
                            showAutoReply
                            && 
                            <div className='auto-reply-options' style={{ bottom: `${inputHeight}px` }}>
                                <div className='auto-reply-option-list'>
                                    {config && config.autoReplies && config.autoReplies.map((reply, index) => {
                                        return (
                                            <div key={index} className='message message_visitor auto-reply-option'>
                                                <div key={index} className='auto-reply-option-content' 
                                                    onClick={() => {
                                                        if (activeVisualTrigger === 'autoReply') {
                                                            setMessages(prev => [...prev, {
                                                                    text: reply.option,
                                                                    msgType: MSG_TYPE_ENUM.AUTO_REPLY_VISITOR,
                                                                    createdAt: { seconds: 2, nanoseconds: 0 },
                                                                    seen: true,
                                                                },
                                                                {
                                                                    text: reply.reply,
                                                                    msgType: MSG_TYPE_ENUM.AUTO_REPLY_CLIENT,
                                                                    createdAt: { seconds: 3, nanoseconds: 0 },
                                                                    seen: true,
                                                                }
                                                            ]);
                                                        } else {
                                                            addMessage({
                                                                text: reply.option,
                                                                msgType: MSG_TYPE_ENUM.AUTO_REPLY_VISITOR,
                                                                createdAt: Timestamp.now(),
                                                                seen: true,
                                                            });
                                                            const autoReplyTime = Timestamp.now();
                                                            autoReplyTime.nanoseconds += 1000;
                                                            addMessage({
                                                                text: reply.reply,
                                                                msgType: MSG_TYPE_ENUM.AUTO_REPLY_CLIENT,
                                                                createdAt: autoReplyTime,
                                                                seen: true,
                                                            });
                                                        }
                                                        setShowAutoReply(false);
                                                    }}
                                                >
                                                    <div className="auto-reply-option-text">
                                                        <span>{reply.option.length > LIMITS.OPTION ? 'Error' : reply.option}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        <Input addMessage={addMessage} showAutoReply={showAutoReply} setShowAutoReply={setShowAutoReply} config={config} inputSize={inputSize} setHeight={setInputHeight} />
                    </>
                );
        }
    }

    return (
        <div className="content">
            { getContent() }
        </div>
    )
}
